import React, { useState } from 'react';
import IconSearch from './svg/IconSearch';
import IconClose from './svg/IconClose';
import PropTypes from 'prop-types';

const AsSearchBar = ({
    onSearchUpdate,
    id = 'searchBar',
    width,
    height,
    placeholder = 'Search ...',
    minSearchLength = 3,
    maxLength = 25,
    currentSearchTerm,
    containerStyle
}) => {
    const [searchTerm, setSearchTerm] = useState(currentSearchTerm);

    containerStyle = {
        display: 'flex',
        alignItems: 'center',
        ...containerStyle
    };

    const fieldStyle = {
        color: '#4A4A4A',
        fontFamily: 'Roboto',
        fontSize: 16,
        paddingLeft: 48,
        marginLeft: -50,
        outline: 'none',
        border: '1px solid #CCCCCC',
        borderRadius: 15,
        backgroundColor: '#FFFFFF',
        display: 'inline',
        width,
        height
    };

    const iconSearchStyle = {
        fill: '#414141',
        marginTop: 2,
        zIndex: 99
    };

    const iconCloseStyle = {
        fill: '#414141',
        paddingBottom: 2,
        marginLeft: -30,
        width: 16,
        height: 16
    };

    const clearSearch = () => {
        setSearchTerm('');
        if (onSearchUpdate) {
            onSearchUpdate('');
        }
    };

    // const debounceTimeout = 300;
    const minLengthToStartSearch = minSearchLength;

    // Get idea of debounce input from https://medium.com/@rajeshnaroth/using-throttle-and-debounce-in-a-react-function-component-5489fc3461b3

    // const delayedSearch = useCallback(
    //     _.debounce((v) => onSearchUpdate(v), debounceTimeout),
    //     []
    // );

    const handleInputUpdate = (event, force = false) => {
        const value = event.target.value;

        setSearchTerm(value);

        if (value.length >= minLengthToStartSearch || value.length === 0 || force) {
            onSearchUpdate(value); // Todo: implement delay differently
        }
    };
    const handleKeyDown = (event) => {
        if (event.code === 'Enter' && searchTerm.length) {
            handleInputUpdate(event, true);
        }
    };

    return (
        <div style={containerStyle}>
            <IconSearch style={iconSearchStyle} />
            <input
                style={fieldStyle}
                placeholder={placeholder}
                value={searchTerm}
                id={id}
                onChange={handleInputUpdate}
                onKeyDown={handleKeyDown}
                maxLength={maxLength}
            />
            {searchTerm && <IconClose style={iconCloseStyle} onClick={clearSearch} />}
        </div>
    );
};

AsSearchBar.propTypes = {
    onSearchUpdate: PropTypes.func.isRequired,
    id: PropTypes.string,
    width: PropTypes.any,
    height: PropTypes.any,
    placeholder: PropTypes.string,
    minSearchLength: PropTypes.number,
    maxLength: PropTypes.number,
    currentSearchTerm: PropTypes.string,
    containerStyle: PropTypes.object
};

export default AsSearchBar;
